<template>
  <v-form ref="form" v-model="valid">
    <v-row>
      <v-col>
        <v-text-field
          color="black"
          label="Your name"
          persistent-hint
          v-model="form.name"
          :rules="rules.name"
        ></v-text-field>

        <v-text-field
          color="black"
          label="Your email"
          type="email"
          persistent-hint
          v-model="form.email"
          :rules="rules.email"
        ></v-text-field>

        <v-text-field
          color="black"
          label="Your subject"
          persistent-hint
          v-model="form.subject"
          :rules="rules.subject"
        ></v-text-field>

        <v-textarea
          auto-grow
          color="black"
          cols="80"
          rows="1"
          label="Your message"
          persistent-hint
          v-model="form.message"
          :rules="rules.message"
        ></v-textarea>

        <p class="terms">By sending your details, you give your consent to process your personal
          data in accordance with CHEF NATURELLE's
          <a href="/privacy" target="_blank">privacy policy</a>.
        </p>
        <div class="text-center mt-3">
          <v-btn
            class="text-center"
            color="primary"
            depressed
            squared
            :disabled="!valid"
            :loading="submitting"
            @click="validate"
          >
            SEND
          </v-btn>
        </div>
      </v-col>
    </v-row>
    <v-snackbar
      v-model="success"
    >
      Thank you! I will get back to you soon.
      <template v-slot:action="{ attrs }">
        <v-btn
          color="white"
          icon
          v-bind="attrs"
          @click="success = false"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </v-form>
</template>

<script>
import MailerService from '@/services/MailerService'
import {
  VBtn,
  VCol,
  VForm,
  VIcon,
  VRow,
  VSnackbar,
  VTextField,
  VTextarea,
} from 'vuetify/lib'
import {Validators} from '@/utils/validators'
import {db} from '@/plugins/firebase'

export default {
  components: {
    VBtn,
    VCol,
    VForm,
    VIcon,
    VRow,
    VSnackbar,
    VTextField,
    VTextarea
  },
  computed: {
    form() {
      return {
        name: '',
        email: '',
        subject: this.subject,
        message: '',
      };
    }
  },
  data: () => ({
    rules: {
      email: [
        value => Validators.required(value) || 'Email is required.',
        value => Validators.email(value),
      ],
      message: [
        value => Validators.required(value) || 'Message is required.'
      ],
      name: [
        value => Validators.required(value) || 'Name is required.'
      ],
      subject: [
        value => Validators.required(value) || 'Subject is required.'
      ]
    },
    submitting: false,
    success: false,
    valid: false
  }),
  methods: {
    validate() {
      if (!this.$refs.form.validate()) {
        return false;
      }

      this.submitting = true

      db.collection('contacts')
          .add({
            createdAt: Date.now(),
            email: this.form.email,
            message: this.form.message,
            name: this.form.name,
            subject: this.form.subject,
            archived: false
          })
          .then(() => MailerService.notify())
          .then(() => {
            this.submitting = false
            this.success = true
            this.$refs.form.reset();
          })
          .catch(() => {})
    }
  },
  props: {
    subject: {
      type: String,
      default: ''
    }
  }
}
</script>

<style>
p.terms {
  font-size: 15px;
  margin-bottom: 0;
}

.thanks {
  color: gray;
}
</style>
